/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_2_ClientInputs */

const et_portfolio_project_2_client = /** @type {(inputs: Portfolio_Project_2_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kodumaa Kinnisvara (Kinnisvarabüroo)`)
};

const en_portfolio_project_2_client = /** @type {(inputs: Portfolio_Project_2_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kodumaa Kinnisvara (Real estate agency)`)
};

/**
* | output |
* | --- |
* | "Kodumaa Kinnisvara (Real estate agency)" |
*
* @param {Portfolio_Project_2_ClientInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_2_client = /** @type {((inputs?: Portfolio_Project_2_ClientInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_2_ClientInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_2_client(inputs)
	return en_portfolio_project_2_client(inputs)
});